export const ORGANIZATION_FEATURE_ADVANCED_NOTIFICATION = 'advanced_notification'
export const ORGANIZATION_FEATURE_VERANSTALTUNG_APP = 'veranstaltung_app'
export const ORGANIZATION_FEATURE_DONATION_METER = 'donation_meter'
